export default "__VITE_ASSET__DEpYn$YA__"